import { render, staticRenderFns } from "./asider.vue?vue&type=template&id=46728f6d&scoped=true&"
import script from "./asider.vue?vue&type=script&lang=js&"
export * from "./asider.vue?vue&type=script&lang=js&"
import style0 from "./asider.vue?vue&type=style&index=0&id=46728f6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46728f6d",
  null
  
)

export default component.exports